<template>
  <div class="user-info">
    <div class="userTitle1">
      <span class="iconfont iconwode">
        <svg
          width="20"
          height="20"
          viewBox="0 0 39 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.0155306 44.0711C0.00492573 44.149 -0.000260386 44.2276 1.00532e-05 44.3063V44.4325C0.012648 44.5835 0.0430235 44.7324 0.0909145 44.8759C0.20741 45.2049 0.42307 45.4897 0.708181 45.691C0.993292 45.8923 1.33382 46.0003 1.68285 46C2.41673 46 3.42998 45.3615 3.40338 44.53C3.40338 35.832 10.4163 29.0275 19.1165 29.0275C19.2207 29.0275 19.2207 25.8745 19.1165 25.8745C8.83102 25.859 0.434577 33.872 0.0155306 44.0711ZM29.3865 32.6992C32.6568 35.648 34.9117 39.7163 34.9117 44.5145C34.8851 45.3459 35.8983 45.9845 36.6324 45.9845C36.9814 45.9848 37.322 45.8769 37.6071 45.6756C37.8922 45.4743 38.1079 45.1896 38.2244 44.8606C38.272 44.7169 38.3028 44.5679 38.3153 44.4172V44.2908C38.3153 44.2123 38.3104 44.1336 38.2997 44.0555C38.1951 41.409 37.5345 38.8141 36.361 36.4396C35.1874 34.0651 33.5272 31.9642 31.4884 30.2736C29.7501 29.012 27.7546 31.227 29.3865 32.6992V32.6992Z"
            fill="#fff"
          />
          <path
            d="M19.1208 0C11.9757 0 6.18359 5.79215 6.18359 12.9372C6.18359 20.0823 11.9757 25.8745 19.1208 25.8745C26.2659 25.8745 32.058 20.0821 32.058 12.9372C32.058 5.79215 26.2659 0 19.1208 0V0ZM19.1208 22.6418C13.7623 22.6418 9.41845 18.2979 9.41845 12.9394C9.41845 7.58097 13.7623 3.23708 19.1208 3.23708C24.4793 3.23708 28.8232 7.58097 28.8232 12.9394C28.8232 18.2979 24.4793 22.6418 19.1208 22.6418Z"
            fill="#fff"
          />
        </svg>
      </span>
      账户信息
    </div>
    <div class="userTitle2">
      <span>个人资料</span>
    </div>
    <div class="userInput">
      登录账号：
      <el-input
        size="medium"
        :disabled="true"
        v-model="userInfo.name"
      ></el-input>
    </div>
    <div class="userInput">
      真实姓名：
      <el-input
        size="medium"
        v-model="userInfo.realName"
        :disabled="true"
        v-if="userInfo.realName"
      ></el-input>
      <el-input
        size="medium"
        v-model="iuserInfo.realName"
        placeholder="请输入真实姓名"
        v-else
      ></el-input>
    </div>
    <div class="userInput">
      用户昵称：
      <el-input
        size="medium"
        v-model="userInfo.nickname"
        :disabled="true"
        v-if="userInfo.nickname"
      ></el-input>
      <el-input
        size="medium"
        v-model="iuserInfo.nickname"
        placeholder="请输入用户昵称"
        v-else
      ></el-input>
    </div>
    <div class="userInput">
      手机号码：
      <el-input
        size="medium"
        v-model="userInfo.phone"
        :disabled="true"
        v-if="userInfo.phone"
      ></el-input>
      <el-input
        size="medium"
        v-model="iuserInfo.phone"
        placeholder="请输入手机号码"
        v-else
        maxlength="11"
      ></el-input>
    </div>

    <div class="userInput">
      生日：
      <el-date-picker
        class="myDatePicker"
        v-if="userInfo.birthday"
        v-model="userInfo.birthday"
        type="date"
        placeholder="请输入生日"
        value-format="timestamp"
        :disabled="userInfo && userInfo.birthday ? true : false"
      ></el-date-picker>
      <el-date-picker
        class="myDatePicker"
        v-else
        v-model="iuserInfo.birthday"
        type="date"
        placeholder="请输入生日"
        value-format="timestamp"
      ></el-date-picker>
    </div>
    <div class="userInput">
      联系 QQ：
      <el-input
        size="medium"
        v-model="userInfo.qq"
        :disabled="true"
        v-if="userInfo.qq"
      ></el-input>
      <el-input
        size="medium"
        v-model="iuserInfo.qq"
        placeholder="请输入常用QQ"
        v-else
      ></el-input>
    </div>
    <div class="userInput">
      联系微信：
      <el-input
        size="medium"
        v-model="userInfo.wechat"
        :disabled="true"
        v-if="userInfo.wechat"
      ></el-input>
      <el-input
        size="medium"
        v-model="iuserInfo.wechat"
        placeholder="请输入常用微信"
        v-else
      ></el-input>
    </div>
    <div class="userInput">
      会员邮箱：
      <el-input
        size="medium"
        v-model="userInfo.email"
        :disabled="true"
        v-if="userInfo.email"
      ></el-input>
      <el-input
        size="medium"
        v-model="iuserInfo.email"
        placeholder="请输入邮箱地址"
        v-else
      ></el-input>
    </div>
    <div class="button">
      <span class="btnUser1" @click="modifyUser">提交</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      iuserInfo: {
        userId: "",
        realName: "",
        nickname: "",
        phone: "",
        qq: "",
        email: "",
        wechat: "",
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    modifyUser() {
      var _this = this;
      if (
        _this.iuserInfo.phone &&
        !this.$utils.checkPhone(_this.iuserInfo.phone)
      ) {
        this.$http.showMesasge("手机号不正确！");
        return;
      }
      if (_this.iuserInfo.qq && !this.$utils.checkQQ(_this.iuserInfo.qq)) {
        this.$http.showMesasge("请正确输入QQ！");
        return;
      }
      if (
        _this.iuserInfo.wechat &&
        !this.$utils.checkWeChat(_this.iuserInfo.wechat)
      ) {
        this.$http.showMesasge("微信号不正确！");
        return;
      }

      if (
        _this.iuserInfo.email &&
        !this.$utils.checkEmail(_this.iuserInfo.email)
      ) {
        this.$http.showMesasge("邮箱不正确！");
        return;
      }

      let _obj = {
        userId: this.userInfo.userId,
        realName: this.iuserInfo.realName || null,
        nickname: this.iuserInfo.nickname || null,
        phone: this.iuserInfo.phone || null,
        birthday: this.iuserInfo.birthday || null,
        qq: this.iuserInfo.qq || null,
        wechat: this.iuserInfo.wechat || null,
        email: this.iuserInfo.email || null,
      };

      console.log(_obj);

      this.$nkhttp.http(this.$api.updateInfo, _obj, "put", (data) => {
        this.$message.success("修改成功");
        this.$store.commit("updataUserInfo", data);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  .userInput {
    width: 400px;
  }
  .userTitle2 {
    margin-bottom: 30px;
  }
  .button {
    padding-left: 100px;
  }
}
</style>